import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rfiQuestionsClient } from '../../lib/connect/clients';
export function useRfiQuestions(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            'rfi-questions',
            rfiResponseProjectId
        ],
        queryFn: ()=>rfiQuestionsClient.listRfiQuestions({
                rfiResponseProjectId
            }),
        enabled: Boolean(rfiResponseProjectId),
        retry: false
    });
}
export function useRfiQuestionMutations(rfiResponseProjectId) {
    const cache = useQueryClient();
    const onSuccess = ()=>cache.invalidateQueries({
            queryKey: [
                'rfi-questions',
                rfiResponseProjectId
            ]
        });
    const create = useMutation({
        mutationFn: (args)=>rfiQuestionsClient.createRfiQuestion({
                ...args,
                rfiResponseProjectId
            }),
        onSuccess
    });
    const review = useMutation({
        mutationFn: (args)=>rfiQuestionsClient.reviewRfiQuestion({
                ...args,
                rfiResponseProjectId
            }),
        onSuccess
    });
    const extract = useMutation({
        mutationFn: (artifactId)=>rfiQuestionsClient.extractRfiQuestions({
                rfiResponseProjectId,
                artifactId
            }),
        onSuccess
    });
    const mapping = useMutation({
        mutationFn: (args)=>rfiQuestionsClient.setRfiQuestionMapping({
                ...args,
                rfiResponseProjectId
            }),
        onSuccess
    });
    return {
        create,
        review,
        extract,
        mapping
    };
}
